import { Component, OnInit, ViewChild } from '@angular/core';
import * as $ from 'jquery';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { Albom } from './Albom';
import { Location } from '@angular/common';
import 'rxjs/add/operator/catch';
import {Globals} from '../globals';

import { NgxImageGalleryComponent, GALLERY_IMAGE, GALLERY_CONF } from "ngx-image-gallery";
@Component({
  selector: 'app-albom',
  templateUrl: './albom.component.html',
  styleUrls: ['./albom.component.scss']
})
export class AlbomComponent implements OnInit {
  albom:Albom;
  url ;
  // headerPic;
  curent = '';
  somethingChanged: any;
dataToSend:any;
p: any = 1;
collection: any[]=[];
tru= false;
 today: any;
 todays: any;

  dateChanged(val: any) {
    var num;
    // console.log('Date changed', val);
    this.somethingChanged = val.value.toString().split(" ");
    // console.log(this.somethingChanged);
    if(this.somethingChanged[1] == "Jan") {
      num = '01';
    } else if(this.somethingChanged[1] == "Feb") {
      num = '02';
    }
    else if(this.somethingChanged[1] == "Mar") {
      num = '03';
    }
    else if(this.somethingChanged[1] == "Apr") {
num = '04';
    }
    else if(this.somethingChanged[1] == "May") {
num = '05';
    }
    else if(this.somethingChanged[1] == "Jun") {
num = '06';
    }
    else if(this.somethingChanged[1] == "Jul") {
num = '07';
    }
    else if(this.somethingChanged[1] == "Aug") {
num = '08';
    }
    else if(this.somethingChanged[1] == "Sep") {
num = '09';
    }
    else if(this.somethingChanged[1] == "Oct") {
num = '10';
    }
    else if(this.somethingChanged[1] == "Nov") {
num = '11';
    }
    else if(this.somethingChanged[1] == "Dec") {
num = '12';
    }
this.dataToSend = this.somethingChanged[3] + "-"+num + "-"+ this.somethingChanged[2]
    // console.log(this.dataToSend)
    this.http.get<Albom>(this.globals.urlMain +'pictures/'+ this.curent , {
      params:{
        data: this.dataToSend
      }

    }).subscribe(data => {
      this.albom = data;
      var k =Number(data.data.photos.pagination.total);

      this.collection=[];
  for(let i =0 ; i<= k; i++) {
    this.collection.push(i)
  }
      // this.headerPic = data.data.header_img;
    });
    // localStorage.setItem('headerImage', this.headerPic ) ;
    $(window).scrollTop(0);
  }
  @ViewChild(NgxImageGalleryComponent) ngxImageGallery: NgxImageGalleryComponent;

  // gallery configuration
  conf: GALLERY_CONF = {
    imageOffset: '0px',
    showDeleteControl: false,
    showImageTitle: false,
    showThumbnails:false
  };
  constructor(private http: HttpClient , private route: ActivatedRoute , public _router:Router , public _location:Location , public globals: Globals) {

    var url_string = location.href;
    this.url = url_string;
    this.curent = url_string.substr(url_string.lastIndexOf('/') + 1);

  }
  lang = localStorage.getItem('lang')?localStorage.getItem('lang'):'hy'
  ngOnInit() {


    this.changel()

    $(window).scrollTop(0);
    setTimeout(()=>{
      $('.loaderParent').hide();

    }, 500)



    this.http.get<Albom>(this.globals.urlMain +'pictures/'+ this.curent).subscribe(data => {
      this.albom = data;

    } );

    setTimeout(()=>{
      $('.loaderParent').hide();
    }, 800)

  }

  openGallery(index: number = 0) {
    this.ngxImageGallery.open(index);
  }
  openModalaudio(event) {
    $('.modalForVideos').addClass('shown');
    var target = event.target || event.srcElement || event.currentTarget;
    var title = $(target).closest('.itemContent').find('.title').text();
    var iframe = $(target).closest('.itemContent').find('img').attr('data-id');
    var audiosrc = $(target).closest('.itemContent').find('audio').attr('data-id');
    var newIframe = document.createElement('img');
    newIframe.src = iframe;
    newIframe.style.width = '100%';
    newIframe.style.objectFit = 'cover';
    // newIframe.allowFullscreen= true;
    // var audio = document.createElement('iframe');
    // audio.src= audiosrc;

    var oldaudio = document.createElement('audio');
    oldaudio.src = audiosrc;
    oldaudio.style.height = '30px';
    oldaudio.style.width = '92%';
    oldaudio.style.position = 'absolute';
    oldaudio.style.bottom = '30px';
    oldaudio.style.zIndex = '9';
    oldaudio.controls = true;
    // $(target).closest('.smallZinuj').remove();
    $('.modalDescription').html('').append(oldaudio);
    $('.modalTitle').html(title);
    $('.modileIframe').html(newIframe);

    // height: 30px;
    // width: 92%;
    // position: absolute;
    // margin-top: 58%;

  };
  openModal(event) {
    console.log('***************************************event***********************************')
    console.log(event)
    $('.modalForVideos').addClass('shown');
    var target = event.target || event.srcElement || event.currentTarget;
    var title = $(target).closest('.itemContent').find('.title').text();
    var iframe = $(target).closest('.itemContent').find('img').attr('data-id');
    var newIframe = document.createElement('iframe');
    newIframe.src = iframe;
    newIframe.height = '100%';
    newIframe.width = '100%';
    newIframe.allowFullscreen = true;
    $('.modalTitle').html(title);
    $('.modileIframe').html(newIframe);

  }

  closeModal() {
    $('.modileIframe').html('');
    $('.modalDescription').html('');
    $('.modalForVideos').removeClass('shown');
  }

  // close gallery
  closeGallery() {
    this.ngxImageGallery.close();
  }

  // set new active(visible) image in gallery
  newImage(index: number = 0) {
    this.ngxImageGallery.setActiveImage(index);
  }

  // next image in gallery
  nextImage(index: number = 0) {
    this.ngxImageGallery.next();
  }

  // prev image in gallery
  prevImage(index: number = 0) {
    this.ngxImageGallery.prev();
  }
	// EVENTS
  // callback on gallery opened
  galleryOpened(index) {
    console.info('Gallery opened at index ', index);
  }

  // callback on gallery closed
  galleryClosed() {
    console.info('Gallery closed.');
  }

  // callback on gallery image clicked
  galleryImageClicked(index) {
    console.info('Gallery image clicked with index ', index);
  }

  // callback on gallery image changed
  galleryImageChanged(index) {
    console.info('Gallery image changed to index ', index);
  }

  // callback on user clicked delete button
  deleteImage(index) {
    console.info('Delete image at index ', index);
  }



changel(){
  this.changeReq();

}
changeReq(){
  $(window).scrollTop(0);
  this.http.get<Albom>(this.globals.urlMain +'pictures/'+this.curent , {
  params:{
     page: this.p,

  }

}).subscribe(data => {
  this.albom = data;

  // console.log(this.slider)
  var k =Number(data.data.photos.pagination.total);
 this.collection=[];
  for(let i =0 ; i<= k; i++) {
    this.collection.push(i)
  }


});



}


}
